
import React, { useState } from 'react';
import axios from 'axios';
import { Button, TextField, Box, Typography, Card, Alert, CardMedia, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import LinearProgress from '@mui/material/LinearProgress';


const ImageRetrieval = () => {
  const [imageName, setImageName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isError, setError] = useState('');
  // State to hold the pre-signed URL
  const [downloadUrl, setDownloadUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const dateConverter = (date) => {
    let myDate = new Date(date)
    return myDate.toISOString()
  };

  const handleRetrieve = async () => {
    setError(false)
    setIsLoading(true);
    try {
      const params = { start: dateConverter(startDate), end: dateConverter(endDate) };
      const response = await axios.get('/aak/fetch-img', { 
        params: params, 
        headers: {
          'Access-Control-Allow-Origin': 'http://*.aakashinfotech',  // CORS settings
          'Content-Type': 'application/x-www-form-urlencoded',   // Ensure content type is correct
          'authorizationToken': imageName
        } 
      });      
      if (response.data && response.data.download_url) {
          setDownloadUrl(response.data.download_url);
          console.log("Download URL set:", response.data.download_url);
      }
    } catch (error) {
      setError(error.message)
      console.error("Error fetching files:", error);
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <Box sx={{ textAlign: 'center', marginTop: 4 }}>
      <Typography variant="h5" gutterBottom marginBottom="3">
        Retrieve Images
      </Typography>
      <Grid container spacing={2} justifyContent="center" marginTop={3}> 
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            fullWidth
            label="Token"
            type="password"
            autocomplete="off"
            value={imageName}
            onChange={(e) => setImageName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={handleRetrieve}
        sx={{ marginTop: 2 }}
      >
        Retrieve Images
      </Button>
      <Grid container spacing={2} justifyContent="center" sx={{ marginTop: 4 }}>
        {isError && <Alert severity="error">{isError}.</Alert>}
        {isLoading &&
            <Box sx={{ width: '100%' }}>
              <LinearProgress color="success" />
            </Box>
        }
        {downloadUrl &&
          <Button variant="contained" href={downloadUrl}>
            Download
          </Button>
        }
      </Grid>
    </Box>
  );
};

export default ImageRetrieval;